import { createContext, useContext } from "react"
import type {
  SummaryAggregations,
  SummaryAggregationType,
} from "./table.summary.types"

type TableSummaryContextValue = {
  /** Whether the summary row renders. Hiding it keeps the calculations. */
  isVisible: boolean
  /** Column id → the calculation its summary cell shows. */
  aggregations: SummaryAggregations
  setIsVisible(isVisible: boolean): void
  /** `null` clears the column's calculation. */
  setAggregation(columnId: string, type: SummaryAggregationType | null): void
}

export const TableSummaryContext =
  createContext<TableSummaryContextValue | null>(null)

export function useTableSummary() {
  const context = useContext(TableSummaryContext)
  if (!context) {
    throw new Error("useTableSummary must be used within a Table")
  }
  return context
}
